export default __webpack_public_path__ + "static/digital_twin_card_mobile-58203fa399b7db6285e9840af586664a.png";